// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-types label[data-v-60593eca]{font-weight:700;margin-top:2em}", "",{"version":3,"sources":["webpack://./resources/assets/js/app/AdminActivityLog.vue"],"names":[],"mappings":"AAAA,qCAAA,eAAA,CAAA,cAAA","sourcesContent":[".filter-types label{font-weight:bold;margin-top:2em}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
